{
  "actionbar.actions": "Radnje",
  "actionbar.actionsAvailable": "Dostupne su radnje.",
  "actionbar.clearSelection": "Poništi izbor",
  "actionbar.selected": "Izabrano: {count}",
  "actionbar.selectedAll": "Sve je izabrano",
  "button.pending": "nerešeno",
  "calendar.invalidSelection": "Izabrani {selectedCount, plural, one {date} other {dates}} nije dostupan.",
  "contextualhelp.help": "Pomoć",
  "contextualhelp.info": "Informacije",
  "datepicker.endTime": "Završno vreme",
  "datepicker.startTime": "Početno vreme",
  "datepicker.time": "Vreme",
  "dialog.alert": "Upozorenje",
  "dialog.dismiss": "Odbaci",
  "dropzone.replaceMessage": "Otpustite datoteku radi zamene",
  "inlinealert.informative": "Informacije",
  "inlinealert.negative": "Greška",
  "inlinealert.notice": "Upozorenje",
  "inlinealert.positive": "Uspešno",
  "label.(optional)": "(opciono)",
  "label.(required)": "(obavezno)",
  "menu.moreActions": "Dodatne radnje",
  "picker.placeholder": "Izaberite...",
  "slider.maximum": "Najviše",
  "slider.minimum": "Najmanje",
  "table.loading": "Učitavam...",
  "table.loadingMore": "Učitavam još...",
  "table.resizeColumn": "Promeni veličinu kolone",
  "table.sortAscending": "Sortiraj po rastućem redosledu",
  "table.sortDescending": "Sortiraj po opadajućem redosledu",
  "tag.actions": "Radnje",
  "tag.hideButtonLabel": "Prikaži manje",
  "tag.noTags": "Ne postoji",
  "tag.showAllButtonLabel": "Prikaži sve ({tagCount, number})",
  "breadcrumbs.more": "Više stavki",
  "combobox.noResults": "Nema rezultata",
  "notificationbadge.indicatorOnly": "Nova aktivnost",
  "notificationbadge.plus": "{notifications}+",
  "toast.clearAll": "Clear all",
  "toast.collapse": "Collapse",
  "toast.showAll": "Show all"
}